import {IElementBase} from './base/elementBase';
import {ELEMENT} from './base/ElementTypes';
import {IElementButton} from './button';
import {IElementTextInput} from './textInput';

export enum FormMethod {
    POST = 'POST',
    PUT = 'PUT',
    GET = 'GET',
    DELETE = 'DELETE',
}

export enum ContentType {
    JSON = 'application/json',
    URLENCODED = 'application/x-www-form-urlencoded',
    FORMDATA = 'multipart/form-data',
}

export type IFormElements = IElementButton | IElementTextInput;
export type FormTarget = '_blank' | '_self' | '_parent' | '_top' | 'framename';

export interface IElementForm extends IElementBase {
    type: ELEMENT.FORM;
    title: string;
    fieldElements: IFormElements[];
    method: FormMethod;
    submitUrl: string;
    fontSize: number;
    target: FormTarget;
    contentType: ContentType;
}
